import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-accommodation-list-product-room',
	templateUrl: './accommodation-list-product-room.component.html',
	styleUrls: ['./accommodation-list-product-room.component.css'],
})
export class AccommodationListProductRoomComponent {
	@Input() room = null;
	constructor() {}
}
